import { ExternalLink } from 'shared/components/ExternalLink/ExternalLink'
import { TextV2 } from 'shared/components/Text/TextV2'
import { useHelpCenterUrl } from 'shared/hooks/useHelpCenterUrl'
import { TYPOGRAPHY } from 'shared/theme/typographyV2'

export function OnboardingInsuranceHelpButton() {
  const insuranceHelpUrl = useHelpCenterUrl('insurance-requirements')
  return insuranceHelpUrl ? (
    <ExternalLink href={insuranceHelpUrl}>Need insurance? Apply</ExternalLink>
  ) : (
    <TextV2 type={TYPOGRAPHY.paragraph2}>Ask your company which insurance documents to provide.</TextV2>
  )
}
